import Vue from 'vue'

/**
 * Páginas
 */
const ListClient = () => import("./views/Clientes/Clientes.vue");
const Comissoes = () => import("./views/comercial/Comissoes.vue");
const Efetividade = () => import("./views/comercial/Efetividade.vue");
const Projetos = () =>
    import(/* webpackChunkName: "projetos" */ "./views/projetos/Projetos.vue");
const Projeto = () =>
    import(/* webpackChunkName: "projeto" */ "./views/projetos/Projeto.vue");
const Ticket = () =>
    import(/* webpackChunkName: "ticket" */ "./views/tickets/Ticket.vue");
const TicketsPgd = () =>
    import(/* webpackChunkName: "tickets-pgd" */ "./views/tickets/Pgd.vue");
const TicketsFinalizados = () =>
    import(/* webpackChunkName: "tickets-finalizados" */ "./views/tickets/Finalizados.vue");
const TicketsStatus = () =>
    import(/* webpackChunkName: "tickets-status" */ "./views/tickets/Status.vue");
const TicketsQuarentena = () =>
    import(/* webpackChunkName: "tickets-quarentena" */ "./views/tickets/Quarentena.vue");
const TicketsEstatisticas = () =>
    import(/* webpackChunkName: "tickets-estatisticas" */ "./views/tickets/Estatisticas.vue");
const ApoioEstatisticas = () =>
    import(/* webpackChunkName: "apoio-estatisticas" */ "./views/apoio/Estatisticas.vue");
const Usuarios = () =>
    import(/* webpackChunkName: "usuarios" */ "./views/usuarios.vue");
const Usuario = () =>
    import(/* webpackChunkName: "usuario" */ "./views/usuario.vue");
const CanalAnonimo = () =>
    import(/* webpackChunkName: "canal-anonimo" */ "./views/canal-anonimo.vue");
const Reclamacoes = () =>
    import(/* webpackChunkName: "reclamacoes" */ "./views/reclamacoes.vue");
const Clientes = () =>
    import(/* webpackChunkName: "clientes" */ "./views/clientes.vue");
const Avisos = () =>
    import(/* webpackChunkName: "avisos" */ "./views/avisos.vue");
const Aviso = () =>
    import(/* webpackChunkName: "avisos" */ "./views/aviso.vue");
const Arvore = () =>
    import(/* webpackChunkName: "arvore" */ "./views/arvore.vue");
const Epicos = () =>
    import(/* webpackChunkName: "epicos" */ "./views/epicos/Epicos.vue");
const Queries = () =>
    import(/* webpackChunkName: "queries" */ "./views/queries/Queries.vue");
const Tools = () =>
    import(/* webpackChunkName: "tools" */ "./views/tools/Tools.vue");
const BIChatsSuporte = () =>
    import(/* webpackChunkName: "bichatssuporte" */ "./views/tools/BIChatsSuporte.vue");
const Configuracoes = () =>
    import(/* webpackChunkName: "configuracoes" */ "./views/configuracoes/Configuracoes.vue");

const listEmails = () =>
    import(/*Lista do vuesax */ "./views/wlist/listEmails.vue")

const listContingency = () =>
  import("./views/fiscal/contingency.vue")

const NetPromoter = () =>
    import("./views/gestao/NetPromoter.vue")

const admConf = () =>
    import("./views/configuracoes/admConf.vue");

const logClientes = () =>
    import("./views/ClientesLogs/ClientesLog.vue")

export {
    ListClient,
    Comissoes,
    Efetividade,
    Projetos,
    Projeto,
    Ticket,
    TicketsQuarentena,
    TicketsPgd,
    TicketsFinalizados,
    TicketsEstatisticas,
    ApoioEstatisticas,
    TicketsStatus,
    Usuarios,
    Usuario,
    CanalAnonimo,
    Reclamacoes,
    Clientes,
    Aviso,
    Avisos,
    Arvore,
    Epicos,
    Queries,
    Tools,
    BIChatsSuporte,
    listEmails,
    listContingency,
    Configuracoes,
    admConf,
    logClientes,
    NetPromoter
};
/**
 * Componentes
 */
const DropdownList = () => import("./components/dropdown-list.vue");
const PgdAndamento = () => import("./views/tickets/components/pgd-andamento.vue");
const PgdTimeline = () => import("./views/tickets/components/pgd-timeline.vue");
const PgdFormCausas = () => import("./views/tickets/components/pgd-form-causas.vue");
const PgdGit = () => import("./views/tickets/components/pgd-git.vue");
const PgdAssociacoes = () => import("./views/tickets/components/pgd-associacoes.vue");
const MonitoracaoDetalhe = () => import("./components/monitoracao-detalhe.vue");
const TicketsTable = () => import("./views/tickets/components/tickets-table.vue");
const TicketsSelect = () => import("./views/tickets/components/tickets-select.vue");
const TableDraggable = () => import("./components/table-draggable.vue");
const TreeNode = () => import("./components/tree-node.vue");
const CustomRender = () =>
    import("./helpers/utils").then(({ CustomRender }) => CustomRender);

const VxCard = () => import("./components/vx-card/VxCard.vue");
const VxList = () => import("./components/vx-list/VxList.vue");
const VxTable = () => import("./components/vx-table/VxTable.vue");
const VxDrawer = () => import("./components/vx-drawer/VxDrawer.vue");
const VxOptions = () => import("./components/vx-option/VxOptions.vue");
const VxOptionsUUID = () => import("./components/vx-option/VxOptionsUUID.vue");
const FeatherIcon = () => import("./components/FeatherIcon.vue");
const DateRangePicker = () => import("./components/DateRangePicker.vue");
const VxBreadcrumb = () => import("./components/VxBreadcrumb.vue");
const VxCheckbox = () => import("./components/vx-checkbox/VxCheckbox.vue");
const VxTooltip = () => import("./containers/components/vx-tooltip/VxTooltip.vue");
const Countdown = () => import("./components/Countdown.vue");

const components = {
    Ticket,
    DropdownList,
    PgdAndamento,
    PgdTimeline,
    PgdFormCausas,
    PgdAssociacoes,
    PgdGit,
    CustomRender,
    MonitoracaoDetalhe,
    TicketsTable,
    TicketsSelect,
    TableDraggable,
    TreeNode,
    VxCard,
    VxList,
    VxTable,
    VxDrawer,
    VxOptions,
    VxOptionsUUID,
    FeatherIcon,
    DateRangePicker,
    VxBreadcrumb,
    VxTooltip,
    VxCheckbox,
    Countdown
};

Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
});
